import React from 'react';
import { Header3 } from 'src/shared/design-system/Headers';
import { HeadlineSpacer } from 'src/shared/design-system/HeadlineSpacer';
import { Modal } from 'src/shared/design-system/Modal';
import { TextReplace } from 'src/shared/design-system/Utilities';
import { followHeader, followingText } from './consts';
import { Avatar, AvatarContainer, AvatarWrapper, CloseButton, FollowIcon, FollowingText } from './styles';
import { FollowModalProps } from './types';

export const FollowModal: React.FC<FollowModalProps> = (props) => {
  const { imageUrl, onClose, isShowing, publicName } = props;
  return (
    <Modal onClose={onClose} isShowing={isShowing} showCloseButton>
      <AvatarContainer>
        <AvatarWrapper>
          <Avatar imageUrl={imageUrl} />
          {isShowing && <FollowIcon />}
        </AvatarWrapper>
      </AvatarContainer>
      <Header3>
        <TextReplace replaceText={publicName} text={followHeader} />
      </Header3>
      <HeadlineSpacer height={2} />
      <FollowingText>{followingText}</FollowingText>
      <CloseButton onClick={onClose} />
    </Modal>
  );
};
